module.exports = __webpack_public_path__ + "images/icons/select-arrow-f21bd7d0.svg";